import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
    Button, Form, Select, Spin,
} from 'antd';
import { getUsersList } from '../../../Manage_retail/redux/actions/get_users_list.actions';
import { assignLeadDeliveryRequestedAgentRequest, assignLeadRequest } from '../../../Manage_retail/redux/actions/assign_lead.actions';
import { debounce, get } from '../../../../../shared/helpers';
import { LEAD_STATUS } from '../../../constants/leadStatuses';

const mapStateToProps = (state) => {
    const {
        users, root_id, assignedTo, current_status,
    } = state.Leads.Lead_profile.Lead_general;
    return {
        users, root_id, assignedTo, current_status,
    };
}; const { Option } = Select; const
    FormItem = Form.Item;

export default connect(mapStateToProps, null)(class AssignLeadModal extends PureComponent {
  state = {
      assignedTo: this.props.assignedTo
          ? `${get(this.props.assignedTo, 'person.first_name')} ${get(this.props.assignedTo, 'person.last_name')}`
          : '',
  };

  handleChange = (value) => this.setState({ assignedTo: value });

  assignLeadFromHeader = () => {
      if (
          this.props.current_status._id === LEAD_STATUS.deliveryRequested
          || this.props.current_status._id === LEAD_STATUS.deliveryRequestedTrade
      ) {
          this.props.dispatch(assignLeadDeliveryRequestedAgentRequest(this.state.assignedTo, this.props.root_id));
      } else {
          this.props.dispatch(assignLeadRequest(this.state.assignedTo, this.props.root_id));
      }
      this.props.closeModal();
  };

  searchUsers = (value) => {
      this.props.dispatch(getUsersList(value));
      this.forceUpdate();
  };

  debouncedSearchUsers = debounce(this.searchUsers, 500);

  handleSearchUsers = (value) => this.debouncedSearchUsers(value);

  render() {
      const { users } = this.props;
      return (
          <Form>
              <FormItem label="Select the agent from the list below">
                  <Select
                      allowClear
                      showSearch
                      id="assignUser"
                      placeholder="Select a person"
                      filterOption={false}
                      notFoundContent="Agent not Found"
                      value={this.state.assignedTo}
                      onSearch={this.handleSearchUsers}
                      onChange={this.handleChange}
                  >
                      <Option value="" style={{ color: 'lightgray' }}>Agent</Option>
                      {users ? users.filter((u) => u.ref_user_status === '5bbb09fb60dc39407f5623aa').map((agent) => (
                          <Option value={agent._id} key={agent._id}>{`${agent.person.first_name} ${agent.person.last_name}`}</Option>
                      )) : []}
                  </Select>
              </FormItem>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button onClick={this.props.closeModal}>Cancel</Button>
                  <Button type="primary" style={{ marginLeft: 10 }} onClick={this.assignLeadFromHeader}>Assign</Button>
              </div>
          </Form>
      );
  }
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/AssignLeadModal.js